import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M18.718 5.282a9.5 9.5 0 0 1 0 13.435 9.5 9.5 0 0 1-13.436 0A9.5 9.5 0 1 1 18.718 5.282Z" />
      <path d="M8 20.619V15.63c0-.47.11-.934.323-1.353L12 7l3.677 7.277c.213.419.323.883.323 1.353v4.989" />
      <path d="m15.924 14.973-1.897 1.423-2.026-1.52-2.026 1.52-1.897-1.423" />
    </g>
  </svg>
);
export default SvgComponent;
